import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";
import { Table, Button } from "react-bootstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const getAuthToken = () => localStorage.getItem("authToken");

const TermExamMarksView = () => {
  const [searchParams] = useSearchParams();
  const term_exam_id = searchParams.get("term_exam_id");
  const batch_id = searchParams.get("batch_id");

  const [students, setStudents] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [marks, setMarks] = useState([]);
  const [loading, setLoading] = useState(true);

  

  const fetchExamMarks = async () => {
  setLoading(true);
  const token = getAuthToken();
  try {
    const res = await axios.post(
      `${appConstants.API_ROOT_URL}get_term_exam_marks`,
      { term_exam_id, batch_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.status === "success") {
      const studentData = res.data.data || [];

      setStudents(studentData);

      // Extract unique subjects from the first student
      if (studentData.length > 0) {
        const subjectList = studentData[0].marks.map((m) => ({
          id: m.subject_id,
          name: m.subject_name,
          max_mark: m.max_mark,
        }));
        setSubjects(subjectList);
      }
    } else {
      alert(res.data.message || "Failed to load data.");
    }
  } catch (err) {
    console.error("Error fetching marks:", err);
    alert("Something went wrong.");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchExamMarks();
  }, [term_exam_id, batch_id]);

  const getMark = (student, subjectId) => {
  const markEntry = student.marks.find((m) => m.subject_id === subjectId);
  return markEntry?.mark_scored ?? "";
};



const handleDownload = () => {
  if (!students.length || !subjects.length) return;

  const data = students.map((stu, index) => {
    const row = {
      No: index + 1,
      Name: stu.name,
    };

    subjects.forEach((subj) => {
      const mark = getMark(stu, subj.id);
      const numMark = parseFloat(mark);
      // If it's a number, use it as number; else keep original
      row[subj.name] = !isNaN(numMark) ? numMark : mark;
    });

    row["Total"] = getTotal(stu); // Already a number
    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(data);

  // Optionally, apply number formatting explicitly
  const range = XLSX.utils.decode_range(worksheet['!ref']);
  for (let R = 1; R <= students.length; ++R) {
    for (let C = 2; C < 2 + subjects.length + 1; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellAddress];
      if (cell && typeof cell.v === "number") {
        cell.t = "n"; // Mark as numeric
      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Term Marks");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, `TermExam_Marks_${batch_id}_${term_exam_id}.xlsx`);
};




  const getTotal = (student) => {
  return student.marks.reduce((sum, m) => {
    const val = m.mark_scored;
    const num = parseFloat(val);
    return !isNaN(num) ? sum + num : sum;
  }, 0);
};



  return (
    <Layout>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-responsive">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <h4>Term Exam Marks</h4>
  <Button variant="success" onClick={handleDownload}>
    Download Excel
  </Button>
</div>

          <Table bordered hover>
            <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                {subjects.map((subj) => (
                  <th key={subj.id}>
                    {subj.name}
                    <br />
                    <small>Max: {subj.max_mark}</small>
                  </th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
  {students.map((stu, index) => (
    <tr key={stu.student_id}>
      <td>{index + 1}</td>
      <td>{stu.name}</td>
      {subjects.map((subj) => (
        <td key={subj.id}>{getMark(stu, subj.id)}</td>
      ))}
      <td>{getTotal(stu)}</td>
    </tr>
  ))}
</tbody>

          </Table>
        </div>
      )}
    </Layout>
  );
};

export default TermExamMarksView;
